import React from 'react';
import RegionMenuTablet from './RegionMenuTablet';
import Services from './Services';
import ComponentSocials from '../../components/ComponentSocials/ComponentSocials';
import BaseComponent from '../../common/BaseComponent/BaseComponent';
import {_isMobile, _isTablet, _manageFingerPrint} from '../../common/helpers/HelperFunc';
import MainMenu from './MainMenu';
import RegionMenu from './RegionMenu';
import ComponentHTMLPreloader from "../ComponentHTMLPreloader/ComponentHTMLPreloader";
import LawBanner from './LawBanner';
import Popup from "../../common/primitives/Popup";
import ComponentCrispChat from "../ComponentCrispChat/ComponentCrispChat";
import styles from './ComponentMainNav.scss';
import mobileMenuImg from './img/mobile-menu.png';
import mobileMenuCloseImg from './img/mobile-menu-close.png';
import tabletClientProfileImg from './img/client_profile_arrow.png';
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";
import {__t} from '../../common/lang/text-resource';

class ComponentMainNav extends BaseComponent {

	isMobile = _isMobile();
	isTablet = _isTablet();
	isMobileVisible = false;
	isServicesVisible = false;
	mountServices = false;
	isServicesAnimationEnded = true;

	cartDividerRef = React.createRef();
	navContainerRef = React.createRef();

	constructor() {
		super(...arguments, 'ComponentMainNav');

		/////////////////////////////////////////////////////////
		//Изчистваме данните от сесията за стъпката на поръчката.
		sessionStorage.removeItem('checkoutStep');
	}

	static whichTransitionEvent() {
		let t;
		let el = document.createElement('fakeelement');
		let transitions = {
			'transition': 'transitionend',
			'OTransition': 'oTransitionEnd',
			'MozTransition': 'transitionend',
			'WebkitTransition': 'webkitTransitionEnd'
		};

		for (t in transitions) {
			if (el.style[t] !== undefined) {
				return transitions[t];
			}
		}
	}

	componentDidMount() {

		_manageFingerPrint();

		super.componentDidMount();

		window.addEventListener('resize', () => {
			const isMobileTMP = _isMobile();
			const isTabletTMP = _isTablet();

			const isServicesVisibleTMP = (isMobileTMP) ? false : this.isServicesVisible;

			let forceUpdate = false;
			if (isMobileTMP !== this.isMobile || isTabletTMP !== this.isTablet) {
				this.isMobile = isMobileTMP;
				this.isTablet = isTabletTMP;
				forceUpdate = true;
			}
			if (isServicesVisibleTMP !== this.isServicesVisible) {
				this.isServicesVisible = (this.isMobile) ? false : this.isServicesVisible;
				forceUpdate = true;
			}
			if (forceUpdate) {
				this.forceUpdate();
			}

		}, false);

		const transitionEvent = ComponentMainNav.whichTransitionEvent();
		const servicesContainer = document.getElementsByClassName(styles.servicesContainer)[0];
		const _this = this;
		transitionEvent && servicesContainer.addEventListener(transitionEvent, function () {
			_this.isServicesAnimationEnded = true;
			_this.forceUpdate();
		});
	}

	eventConsume(eventName, eventData) {
		if (eventName === 'ToggleCart') {
			if (this.cartDividerRef.current) {
				if (eventData.isOpen) {
					this.cartDividerRef.current.classList.add(styles.cartOpened);
				} else {
					this.cartDividerRef.current.classList.remove(styles.cartOpened);
				}
			}
		}
		if (eventName === 'MainDomainSelectPopupToggled' || eventName === 'DomainContactDataPopupToggled' || eventName === 'NoCompanySelectedPopupOpened') {
			const {visible} = eventData;
			if (visible) {
				this.navContainerRef.current.style.zIndex = 0;
			} else {
				this.navContainerRef.current.style.zIndex = 999;
			}
		}
	}

	changeLanguage = (langCode) => {
		let hostPrefixMap = {
			"en": "en.",
			"bg": "",
		};

		window.location.href = window.location.href.replace("://en.", "://").replace("://www.", "://").replace("://", "://" + hostPrefixMap[langCode]);
	};

	toggleServices = () => {
		this.isServicesAnimationEnded = false;
		this.isServicesVisible = !this.isServicesVisible;
		this.mountServices = this.isServicesVisible;
		this.forceUpdate();
	};

	toggleMobileMenu = () => {
		this.isMobileVisible = !this.isMobileVisible;
		this.isServicesVisible = false;
		this.forceUpdate();
	};

	render() {
		let currentLanguage = {
			id: 'bg',
			name: __t('Български')
		};

		let allLanguages = [
			{id: 'bg', name: __t('Български')},
			{id: 'en', name: __t('Английски')},
		];

		let profileLink = null;
		let customerName = '';

		let data = this.context.get(this.componentName);

		if (data) {
			this.componentToken = data.componentToken;

			data = data.componentData;

			currentLanguage = allLanguages.find(lang => lang.id == data.currentLang);
			profileLink = data.profileLink;
			customerName = data.customerName;
		}

		let preloader = this.context.get('ComponentHTMLPreloader');

		const classes = [styles.mainNav];
		if (this.props.withoutCart) {
			classes.push(styles.withoutCart);
		}
		if (this.isMobile) {
			classes.push(styles.mobile);
		}
		if (this.isMobileVisible) {
			classes.push(styles.mobileVisible);
		}
		if (!this.isServicesAnimationEnded || this.isServicesVisible) {
			classes.push(styles.servicesVisible);
		}

		return (
		  <div
			ref={this.navContainerRef}
			className={`${styles.mainContainer} ${(this.isMobile) && this.isMobileVisible ? styles.mobile : null} ${this.props.showCartDivider ? styles.withOldCart : ''}`}>
			  <div
				className={classes.join(' ')}>
				  <div className={`${styles.container}`}>
					  {/*~~~~~~~~~~~~~~~~~*/}
					  {/*Menu public begin*/}
					  {/*~~~~~~~~~~~~~~~~~*/}
					  <div>
						  {
							this.props.showCartDivider &&

							<div data-layout="container" ref={this.cartDividerRef} className={styles.cartDivider}>
								<div/>
							</div>
						  }
						  {preloader ? <ComponentHTMLPreloader data={preloader}/> : ''}
						  {/*~~~~~~~~~~~~~~~~~*/}
						  {/* Main menu begin */}
						  {/*~~~~~~~~~~~~~~~~~*/}
						  <MainMenu
							isMobileVisible={this.isMobileVisible}
							isMobile={this.isMobile}
							isServicesVisible={this.isServicesVisible}
							toggleServices={this.toggleServices}/>
						  {/*~~~~~~~~~~~~~~~~~*/}
						  {/* Main menu End   */}
						  {/*~~~~~~~~~~~~~~~~~*/}

						  {/*~~~~~~~~~~~~~~~~~~~*/}
						  {/* Region menu begin */}
						  {/*~~~~~~~~~~~~~~~~~~~*/}
						  {
							  data ?
								this.isTablet ?
								  <RegionMenuTablet
									currentLanguage={currentLanguage}
									allLanguages={allLanguages}
									changeLanguage={this.changeLanguage}/>
								  :
								  <RegionMenu
									isMobileVisible={this.isMobileVisible}
									isMobile={this.isMobile}
									currentLanguage={currentLanguage}
									allLanguages={allLanguages}
									changeLanguage={this.changeLanguage}/>
								: ''
						  }
						  {/*~~~~~~~~~~~~~~~~~*/}
						  {/* Region menu end */}
						  {/*~~~~~~~~~~~~~~~~~*/}
						  {/*~~~~~~~~~~~~~~~~~~~*/}
						  {/* Client menu begin */}
						  {/*~~~~~~~~~~~~~~~~~~~*/}
						  {
							  (this.isTablet) ?
								<div className={`${styles.clientProfileTabletBtn} preload_remove`}
									 data-hj-suppress={"true"}>
									<a
									  href={profileLink}>
										<img src={tabletClientProfileImg} alt={__t("Клиентски профил")}/>
									</a>
								</div>
								:
								(this.isMobile) ?
								  (this.isMobileVisible) ?
									<div className={`${styles.clientProfile} preload_remove`}
										 data-hj-suppress={"true"}>
										<a
										  href={profileLink}>
											{(customerName !== '') ? customerName : __t('Клиентски профил')}
										</a>
									</div>
									:
									<button className={styles.mobileMenuBtn} onClick={this.toggleMobileMenu}>
										<img src={mobileMenuImg} alt={__t("Меню")}/>
									</button>
								  :
								  <div className={`${styles.clientProfile} preload_remove`}
									   data-hj-suppress={"true"}>
									  {(profileLink) ?
										<a
										  href={profileLink}>
											{(customerName !== '') ? customerName : __t('Клиентски профил')}
										</a> : null
									  }
								  </div>
						  }
						  {/*~~~~~~~~~~~~~~~~~~~*/}
						  {/* Client menu end */}
						  {/*~~~~~~~~~~~~~~~~~~~*/}

					  </div>
					  {/*~~~~~~~~~~~~~~~~~*/}
					  {/*Menu public end  */}
					  {/*~~~~~~~~~~~~~~~~~*/}
				  </div>
				  {
					  (this.isMobile && this.isMobileVisible) ?
						<button className={styles.mobileMenuBtnClose} onClick={this.toggleMobileMenu}>
							<img src={mobileMenuCloseImg} alt={__t("Затвори")}/>
						</button>
						: null
				  }
			  </div>

			  <div
				className={`${styles.servicesContainer} ${this.isServicesVisible ? styles.isVisible : null} ${this.props.promoBarVisible ? styles.promoBar : null}`}>
				  <Services isMobile={false} toggleServices={() => {
					  if (this.isServicesVisible && !this.isMobile) {
						  this.toggleServices();
					  }
				  }}/>
			  </div>
			  <ComponentSocials data={{}}/>
			  <ComponentCrispChat data={{}}/>

			  <Popup name={'term_not_checked'}
					 isVisible={false}
					 closeButton={__t('Затваряне')}
					 data={{}}
					 content={
						 {
							 heading: '',
							 paragraphs: [__t('моля-уверете-се-че-сте-запознати-с-общите-условияaabfa2')]
						 }
					 }/>
			  <Popup
				name={'payment_way_not_selected'}
				isVisible={false}
				data={{}}
				closeButton={__t('Затваряне')}
				content={
					{
						heading: '',
						paragraphs: [__t('невалиден-начин-на-плащане-моля-изберете-един-от-dd74e8')]
					}
				}/>
		  </div>
		);
	}
}

// React Context binding
ComponentMainNav.contextType = ContextDataStore;

export default ComponentMainNav;